import { ViewStore } from "@priolo/jack"

export { docsSo as default, DRAWER_POSITION, FIXED_CARD } from "@priolo/jack"

export const fixedViews:ViewStore[] = []
